import React from "react"
import {Page} from "../../components-shared/page/page"
import {ClimateAdvice} from "./climate-advice"

export const ClimateAdvicePage: React.FC = () => {
  return <Page title="Klimaatadvies">
    <ClimateAdvice/>
  </Page>
}